import meta from './meta/reducer';
import room from './room/reducer';
import board from './board/reducer';
import surrounding from './surrounding/reducer';
import facility from './facility/reducer';
// 이는 바깥에서 combine해준다.
export default {
  meta,
  room,
  surrounding,
  board,
  facility
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js